var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCurrentPosted = function SvgCurrentPosted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-235 -994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon.BG",
    transform: "translate(235 994)",
    fill: "#fff",
    stroke: "#F1AE38",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "money-bag-icon",
    d: "M-227.408-1011a3.359,3.359,0,0,1-2.768-1.5,3.02,3.02,0,0,1,0-3l3.514-6a1.136,1.136,0,0,1,.958-.5h4.258a1.135,1.135,0,0,1,.958.5l3.514,6a3.013,3.013,0,0,1,0,3,3.359,3.359,0,0,1-2.768,1.5Zm1.7-13a1,1,0,0,1-.745-.3l-1.065-1a.975.975,0,0,1,.745-1.7h6.387a.993.993,0,0,1,.745,1.7l-1.065,1a1,1,0,0,1-.745.3Z",
    transform: "translate(477.575 2032)",
    fill: "#F1AE38"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCurrentPosted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/currentPosted.361821ec.svg";
export { ForwardRef as ReactComponent };